import { USER_FORGOT_CREDENTIAL } from './types'

const userForgotCredential = credential => ({
  type: USER_FORGOT_CREDENTIAL,
  payload: credential
})

export { userForgotCredential }
